import type { ServiceConfig } from './types'

// Uma fila só entra no painel do operador se estiver configurada de verdade:
// precisa ter sala física e ao menos um serviço vinculado.
export function isOperatorReadyServiceConfig(serviceConfig: ServiceConfig): boolean {
  return serviceConfig.sala.trim().length > 0 && serviceConfig.serviceIds.length > 0
}
